import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M2 18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v2z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M10 10V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 15v-3a6 6 0 0 1 6-6h0", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 6h0a6 6 0 0 1 6 6v3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "HardHat";
const HardHat = memo(themed(Icon));
export {
  HardHat
};
//# sourceMappingURL=hard-hat.js.map
